import React from 'react';
import { useRecordContext } from 'react-admin';
import Chip from '@mui/material/Chip';

const priorityConfig = {
    low: { label: 'Low', color: 'info' },
    normal: { label: 'Normal', color: 'default' },
    high: { label: 'High', color: 'warning' },
    urgent: { label: 'Urgent', color: 'error' }
};

const PriorityField = () => {
    const record = useRecordContext();
    if (!record || !record.priority) return null;

    const config = priorityConfig[record.priority] || { label: record.priority, color: 'default' };

    return <Chip label={config.label} color={config.color} size="small" />;
};

export default PriorityField;
